module.exports = __webpack_public_path__ + "img/white-logo.a0961c74.svg";